import { render, staticRenderFns } from "./TicketSkeletonTemplate.vue?vue&type=template&id=a027700c&"
import script from "./TicketSkeletonTemplate.vue?vue&type=script&lang=ts&"
export * from "./TicketSkeletonTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports